import { Dispatch, Reducer, createContext } from 'react';

interface MiniCartContextState {
  showEmailForm?: boolean;
  serverErrorMessage?: string;
  showThankyouMessage?: boolean;
  emailFormProcessing?: boolean;
  emailFormData?: {
    email?: string;
    emailErrorMessage?: string;
    firstName?: string;
    firstNameErrorMessage?: string;
    lastName?: string;
    lastNameErrorMessage?: string;
    company?: string;
    companyErrorMessage?: string;
  };
}

//#region action type
enum MiniCartContextActionTypeEnum {
  SetShowEmailForm = 'SET_SHOW_EMAIL_FORM',
  SetEmailFormData = 'EMAIL_FORM_DATA',
  SetServerErrorMessage = 'SET_SERVER_ERROR_MESSAGE',
  SetShowThankyouMessage = 'SET_SHOW_THANKYOU_MESSAGE',
  SetEmailFormProcessing = 'SET_EMAIL_FORM_PROCESSING',
}

interface SetShowEmailFormAction {
  type: MiniCartContextActionTypeEnum.SetShowEmailForm;
  payload: boolean;
}

interface SetEmailFormDataAction {
  type: MiniCartContextActionTypeEnum.SetEmailFormData;
  payload: any;
}

interface SetServerErrorMessageAction {
  type: MiniCartContextActionTypeEnum.SetServerErrorMessage;
  payload: string;
}

interface SetShowThankyouMessageAction {
  type: MiniCartContextActionTypeEnum.SetShowThankyouMessage;
  payload: boolean;
}

interface SetEmailFormProcessingAction {
  type: MiniCartContextActionTypeEnum.SetEmailFormProcessing;
  payload: boolean;
}

type MiniCartContextAction =
  | SetShowEmailFormAction
  | SetEmailFormDataAction
  | SetServerErrorMessageAction
  | SetShowThankyouMessageAction
  | SetEmailFormProcessingAction;
//#endregion

interface MiniCartContextModel {
  state?: MiniCartContextState;
  dispatch?: Dispatch<MiniCartContextAction>;
}

const MiniCartContext = createContext<MiniCartContextModel>({});

const miniCartContextReducer: Reducer<MiniCartContextState, MiniCartContextAction> = (prevState, action) => {
  let payload, newState;

  switch (action.type) {
    case MiniCartContextActionTypeEnum.SetShowEmailForm:
      payload = (action as SetShowEmailFormAction).payload;

      return { ...prevState, showEmailForm: payload };
    case MiniCartContextActionTypeEnum.SetEmailFormData:
      payload = (action as SetEmailFormDataAction).payload;

      return { ...prevState, emailFormData: payload };
    case MiniCartContextActionTypeEnum.SetServerErrorMessage:
      payload = (action as SetServerErrorMessageAction).payload;

      return { ...prevState, serverErrorMessage: payload };
    case MiniCartContextActionTypeEnum.SetShowThankyouMessage:
      payload = (action as SetShowThankyouMessageAction).payload;

      return { ...prevState, showThankyouMessage: payload };
    case MiniCartContextActionTypeEnum.SetEmailFormProcessing:
      payload = (action as SetEmailFormProcessingAction).payload;

      return { ...prevState, emailFormProcessing: payload };
    default:
      return prevState;
  }
};

export { MiniCartContext, MiniCartContextActionTypeEnum, miniCartContextReducer };
export type { MiniCartContextState, MiniCartContextAction };
